
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import vSelect3 from "vselect3";
import { DeviceTypeAdvancedFilterRule } from "@/types/sv-data/system-view/advanced-filters/AdvancedStatusFilterRules";

interface DeviceTypeOption {
	title: string,
	value: number
}

@Component({
	components: {
		"v-select-3": vSelect3
	}
})
export default class DeviceTypeAdvancedFilter extends Vue {
	@Prop(Object) value: DeviceTypeAdvancedFilterRule;

	public static readonly RuleIdentifier: string = "DeviceType";

	private options: DeviceTypeOption[] = [
		{ title: "Alarms", value: -1 },
		{ title: "Camera", value: 1 },
		{ title: "Audio", value: 2 },
		{ title: "Relay", value: 3 },
		{ title: "Split Camera", value: 4 }
	];

	private ruleSettings: DeviceTypeAdvancedFilterRule = {
		filterRuleType: DeviceTypeAdvancedFilter.RuleIdentifier,
		deviceType: -1,
		enabled: false
	};

	private async mounted(): Promise<void> {
		if(this.value !== null) {
			this.ruleSettings = this.value;
		}
	}

	@Watch("ruleSettings", { deep: true })
	private async ruleUpdated(): Promise<void> {
		this.$emit("input", this.ruleSettings);
	}
}
